module.exports = __webpack_public_path__ + "img/header.21f32a5a.png";